export default __webpack_public_path__ + "3e6b99809852a8290c42c97dc1b66efb.woff";